import { gql } from 'apollo-boost';

export const allQuicksightDashboard = gql`
query {
  allQuicksightDashboard {
    edges {
        node {
            id
            dbId
            accountId
            name
            information
            awsId
            accountList
        }
    }
  }
}
`;
